
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReport07SkuDialog extends Serenity.EntityDialog<IcReport07SkuRow, any> {
        protected getFormKey() { return IcReport07SkuForm.formKey; }
        protected getIdProperty() { return IcReport07SkuRow.idProperty; }
        protected getLocalTextPrefix() { return IcReport07SkuRow.localTextPrefix; }
        protected getNameProperty() { return IcReport07SkuRow.nameProperty; }
        protected getService() { return IcReport07SkuService.baseUrl; }
        protected getDeletePermission() { return IcReport07SkuRow.deletePermission; }
        protected getInsertPermission() { return IcReport07SkuRow.insertPermission; }
        protected getUpdatePermission() { return IcReport07SkuRow.updatePermission; }

        protected form = new IcReport07SkuForm(this.idPrefix);

    }
}